/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
import React from 'react'
import moment from 'moment'
import _ from 'lodash'
import qs from 'querystring'
import { Icon } from 'semantic-ui-react'
import * as XLSX from 'xlsx'

const getLoggedDevicePlatform = (loggedUUID, style = {}) => {
  return (
    loggedUUID && (
      <Icon
        size="large"
        name={loggedUUID.includes('-') ? 'apple' : 'android'}
        color={loggedUUID.includes('-') ? 'grey' : 'green'}
        style={style}
      />
    )
  )
}

const getBatteryStatus = (battery, isNotPercent = false) => {
  let batteryPercent

  if (isNotPercent) {
    batteryPercent = battery
  } else {
    batteryPercent = parseInt(battery * 100, 10)
  }

  let color = ''
  let icon = ''

  if (_.inRange(batteryPercent, 0, 10)) {
    icon = 'battery empty'
    color = 'red'
  } else if (_.inRange(batteryPercent, 10, 20)) {
    icon = 'battery quarter'
    color = 'red'
  } else if (_.inRange(batteryPercent, 20, 40)) {
    icon = 'battery quarter'
    color = 'orange'
  } else if (_.inRange(batteryPercent, 40, 60)) {
    icon = 'battery half'
    color = 'orange'
  } else if (_.inRange(batteryPercent, 60, 90)) {
    icon = 'battery three quarters'
    color = 'olive'
  } else if (_.inRange(batteryPercent, 90, 100)) {
    icon = 'battery full'
    color = 'green'
  } else if (batteryPercent === 100) {
    icon = 'battery full'
    color = 'green'
  } else {
    icon = 'battery empty'
    color = 'red'
  }

  return {
    color,
    icon,
  }
}

const getOrderStatus = status => {
  let label = ''
  let color = ''

  switch (status) {
    case 'pending':
      label = 'Pending'
      color = 'yellow'
      break
    case 'confirmed':
      label = 'Confirmed'
      color = 'yellow'
      break
    case 'outForDelivery':
      label = 'Out for delivery'
      color = 'yellow'
      break
    case 'rejected':
      label = 'Rejected'
      color = 'red'
      break
    case 'delivered':
      label = 'Delivered'
      color = 'green'
      break
    default:
      label = status
      color = 'orange'
  }

  return {
    label,
    color,
  }
}

const getCreditStatusColor = credit => {
  let color = ''

  if (credit <= 5) {
    color = 'red'
  } else if (_.inRange(credit, 5, 10)) {
    color = 'orange'
  } else if (_.inRange(credit, 10, 20)) {
    color = 'olive'
  } else if (credit >= 20) {
    color = 'green'
  }

  return color
}

const getDriverStatusColor = status => {
  switch (status) {
    case 'available':
      return 'green'
    case 'busy':
      return 'red'
    case 'waiting_for_confirm':
      return 'orange'
    default:
      return ''
  }
}

const convertToFixedTwo = number => Number(parseFloat(number).toFixed(2))
const convertToCurrency = (amount, currency = '$') => `${currency} ${convertToFixedTwo(amount)}`

const getDriverStatistic = (orders, dateLength) => {
  const drivers = {}
  const commissionRate = 25 / 100
  const driverEarningRate = 1 - commissionRate

  _.each(orders, order => {
    const { deliverer_key, delivery_fee, status, created_at } = order

    if (status !== 'delivered') return
    const dateStamp = moment(created_at).format('DDMMM')

    drivers[deliverer_key] = drivers[deliverer_key] || {
      orderCount: 0,
      totalDeliveryFee: 0,
      orderAt: {},
    }
    drivers[deliverer_key]['orderAt'][dateStamp] = drivers[deliverer_key]['orderAt'][dateStamp] || {}
    drivers[deliverer_key]['orderAt'][dateStamp]['count'] =
      drivers[deliverer_key]['orderAt'][dateStamp]['count'] || 1
    drivers[deliverer_key]['orderAt'][dateStamp]['deliveryFee'] =
      drivers[deliverer_key]['orderAt'][dateStamp]['deliveryFee'] || 0
    drivers[deliverer_key].orderCount += 1
    drivers[deliverer_key]['orderAt'][dateStamp]['count'] += 1
    drivers[deliverer_key]['orderAt'][dateStamp]['deliveryFee'] += delivery_fee
    drivers[deliverer_key].totalDeliveryFee += delivery_fee
  })

  const allDriverStatistic = Object.values(drivers)
  const allDriverCount = allDriverStatistic.length

  if (allDriverCount === 0) {
    return {
      allDriverCount: 0,
      maxOrderCount: 0,
      minOrderCount: 0,
      avgOrderCount: 0,
      driverOrderUnderAverage: 0,
      maxEarning: 0,
      minEarning: 0,
      avgEarning: 0,
      dailyAvgEarning: 0,
      avgCommission: 0,
      fullyFilledDriverCount: 0,
    }
  }

  let maxOrderCount = 0
  let minOrderCount = 0
  let allOrderCount = 0

  let maxEarning = 0
  let minEarning = 0
  let allDriverEarning = 0
  let fullyFilledDriverCount = 0
  let averageDailyDriverEarning = []

  for (let i = 0; i < allDriverCount; i += 1) {
    const driverStatistic = allDriverStatistic[i]

    if (driverStatistic.orderCount > maxOrderCount) {
      maxOrderCount = driverStatistic.orderCount
    }
    if (driverStatistic.orderCount < minOrderCount || i === 0) {
      minOrderCount = driverStatistic.orderCount
    }
    allOrderCount += driverStatistic.orderCount

    if (driverStatistic.totalDeliveryFee > maxEarning) {
      maxEarning = driverStatistic.totalDeliveryFee
    }
    if (driverStatistic.totalDeliveryFee < minEarning || i === 0) {
      minEarning = driverStatistic.totalDeliveryFee
    }
    allDriverEarning += driverStatistic.totalDeliveryFee
  }

  const avgOrderCount = convertToFixedTwo(allOrderCount / allDriverCount)
  const driverOrderUnderAverage = allDriverStatistic.filter(
    driverStats => driverStats.orderCount >= avgOrderCount
  ).length

  _.each(allDriverStatistic, driverStat => {
    fullyFilledDriverCount += Object.keys(driverStat.orderAt).length === dateLength ? 1 : 0
    averageDailyDriverEarning.push(_.mean(_.map(driverStat.orderAt, date => date.deliveryFee)))
  })
  return {
    allDriverCount,
    fullyFilledDriverCount,
    maxOrderCount,
    minOrderCount,
    avgOrderCount,
    driverOrderUnderAverage,
    maxEarning: convertToCurrency(maxEarning * driverEarningRate),
    minEarning: convertToCurrency(minEarning * driverEarningRate),
    avgCommission: convertToCurrency((allDriverEarning / allDriverCount) * commissionRate),
    avgEarning: convertToCurrency((allDriverEarning / allDriverCount) * driverEarningRate),
    dailyAvgEarning: convertToCurrency(_.mean(averageDailyDriverEarning)),
  }
}

const getOrderLatency = ({
  eta: orderTookEta,
  status,
  delivery_time: deliveryTime,
  created_at: createdAt,
  updated_at: updatedAt,
}) => {
  if (status === 'rejected') return 0

  const isScheduled = deliveryTime !== undefined && deliveryTime !== 'ETA'
  const orderStartedAt = moment(Number(createdAt))
  const orderEndedAt = moment(Number(updatedAt))

  if (isScheduled) {
    const eta = moment(deliveryTime)
    return Math.ceil(moment.duration(eta.diff(orderEndedAt)).asMinutes())
  }

  const duration = moment.duration(orderEndedAt.diff(orderStartedAt)).as('minutes')
  const remaining = parseInt(orderTookEta - duration, 10)

  return remaining
}

const getLatencyStatistic = orders => {
  const allOrderCount = orders.length
  let allLateOrderDuration = 0
  let successOrderCount = 0
  let lateOrderCount = 0
  let slowestLateOrder = 0
  let fatestLateOrder = 0

  for (let i = 0; i < allOrderCount; i += 1) {
    const order = orders[i]
    const orderLatency = getOrderLatency(order)

    if (order.status === 'delivered') {
      successOrderCount += 1
    } else {
      continue
    }

    if (orderLatency >= 0) continue

    if (orderLatency > fatestLateOrder || lateOrderCount === 0) {
      fatestLateOrder = orderLatency
    }

    if (orderLatency < slowestLateOrder) {
      slowestLateOrder = orderLatency
    }

    lateOrderCount += 1
    allLateOrderDuration += orderLatency
  }
  return {
    successOrderCount,
    lateOrderCount,
    slowestLateOrder,
    fatestLateOrder,
    latePossibility: lateOrderCount > 0 ? convertToFixedTwo(lateOrderCount / successOrderCount) : 0,
    avgLateOrder: lateOrderCount > 0 ? Math.round(allLateOrderDuration / lateOrderCount) : 0,
  }
}

const getRowsTimeSlot = (allTimeSlot, orders) => {
  let mergeRowTime = {}

  const { online = undefined, offline = undefined } = allTimeSlot

  if (online) {
    _.map(online, ({ count }, timeslot) => {
      const formattedHour = moment(timeslot, 'hh').format('LT')

      mergeRowTime[formattedHour] = {
        hour: parseInt(moment(timeslot, 'hh').format('H'), 10),
        formattedHour,
        onlineCount: count || 0,
        offlineCount: (mergeRowTime[formattedHour] && mergeRowTime[formattedHour].offlineCount) || 0,
      }
    })
  }

  if (offline) {
    _.map(offline, ({ count }, timeslot) => {
      const formattedHour = moment(timeslot, 'hh').format('LT')

      mergeRowTime[formattedHour] = {
        hour: parseInt(moment(timeslot, 'hh').format('H'), 10),
        formattedHour,
        onlineCount: (mergeRowTime[formattedHour] && mergeRowTime[formattedHour].onlineCount) || 0,
        offlineCount: count || 0,
      }
    })
  }

  mergeRowTime = _.orderBy(mergeRowTime, 'hour', 'asc')

  const muuverLifeSpan = []
  const orderLifeSpan = []
  const onlineLifeSpan = []
  const offlineLifeSpan = []
  const chartLabels = []
  const latency = []

  _.map(mergeRowTime, (rowTimeData, index) => {
    muuverLifeSpan[index] = (muuverLifeSpan[index - 1] || 0) + (rowTimeData.onlineCount || 0)
    muuverLifeSpan[index] = (muuverLifeSpan[index] || 0) - (rowTimeData.offlineCount || 0)

    muuverLifeSpan[index] = muuverLifeSpan[index] < 0 ? 0 : muuverLifeSpan[index]

    const ordersByTimeSlot = _.filter(orders, orderValue => {
      const formattedTimeslot = moment(parseInt(orderValue.created_at, 10))
        .minute(0)
        .format('h:mm A')

      return formattedTimeslot === rowTimeData.formattedHour
    })
    orderLifeSpan[index] = _.size(ordersByTimeSlot)
    chartLabels[index] = rowTimeData.formattedHour
    onlineLifeSpan[index] = rowTimeData.onlineCount || 0
    offlineLifeSpan[index] = rowTimeData.offlineCount || 0
    latency[index] = getLatencyStatistic(ordersByTimeSlot)
  })

  return {
    mergeRowTime,
    muuverLifeSpan,
    orderLifeSpan,
    chartLabels,
    onlineLifeSpan,
    offlineLifeSpan,
    latency,
  }
}

const getOrderEta = (orderValue, stores) => {
  let durationOfDistance = 45
  const findingDriver = 10
  const callingPartner = 5
  const groupCartPlus = orderValue.is_group_order ? 10 : 0
  let preparationTime = 15

  const storeId = orderValue.restaurant.key

  if (orderValue.etaInfo.info.legs[0].duration_in_traffic !== undefined) {
    durationOfDistance = parseInt(orderValue.etaInfo.info.legs[0].duration_in_traffic.value / 60, 10)
  } else {
    durationOfDistance = parseInt(orderValue.etaInfo.info.legs[0].duration.value / 60, 10)
  }

  if (stores[storeId] && stores[storeId].cooking_duration) {
    preparationTime = Number(parseInt(stores[storeId].cooking_duration, 10))
  }

  const eachETA = durationOfDistance + findingDriver + preparationTime + callingPartner + groupCartPlus

  return eachETA
}

const convertToLocalPhoneNumber = (tel = '') => {
  if (!tel) return

  let phoneNumber = tel.replace('+', '').replace(new RegExp(/\s+/, 'g'), '')

  if (phoneNumber.startsWith('855')) {
    phoneNumber = phoneNumber.replace('855', 0)
  }

  return phoneNumber
}

const copyToClipboard = text => {
  if (!text) return

  const el = document.createElement('textarea')
  el.value = text
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}

const urlParamsObjectify = searchString => {
  return JSON.parse(
    `{"${decodeURI(searchString)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')}"}`
  )
}

const numberWithCommas = amount => {
  return parseFloat(amount)
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const numberToUsd = amount => {
  return `${numberWithCommas(amount)} USD`
}

const numberToRiel = amount => {
  return `${Math.round(parseFloat(amount))
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} KHR`
}

// eslint-disable-next-line no-script-url
const convertToCallableLink = tel => (tel ? `zoiper://${tel}` : 'javascript:void(0)')

const convertArrayToObject = (array = [], key) => {
  const count = array.length
  const object = {}

  for (let index = 0; index < count; index += 1) {
    const element = array[index]
    object[element[key]] = element
  }

  return object
}

const urlParams = () => {
  const search = window.location.search.replace('?', '')
  return qs.parse(search)
}

const isDev = (() => {
  const query = urlParams()

  return query.dev ? query.dev === 'true' : false
})()

const filterActiveSpecialDeal = specialDeal => {
  const now = Number(moment().format('x'))

  if (!specialDeal || specialDeal.started_at > now || specialDeal.ended_at <= now) return {}

  const availableItems = _.pickBy(specialDeal.items, item => !item.sold_out && item.sold <= item.quantity)

  if (_.size(availableItems) === 0) return {}

  return {
    items: availableItems,
    endedAt: specialDeal.ended_at,
    startedAt: specialDeal.started_at,
  }
}

const filterSpecialDealByMerchant = (merchantId, specialDeals) => {
  const specialDealItems = {}

  _.forEach(specialDeals, ({ items }) =>
    _.forEach(items, (item, itemKey) => {
      if (merchantId === item.merchant_id) {
        specialDealItems[itemKey] = item
      }
    })
  )

  return specialDealItems
}

const getJsonDataFromExcel = file =>
  new Promise(resolve => {
    const reader = new FileReader()

    reader.onload = evt => {
      const { result } = evt.target
      const workBook = XLSX.read(result, { type: 'binary' })

      const sheetName = workBook.SheetNames[0]
      const workSheet = workBook.Sheets[sheetName]

      const data = XLSX.utils.sheet_to_json(workSheet, { header: 1 })

      resolve(data)
    }

    reader.readAsBinaryString(file)
  })

const getDataFromJSON = file =>
  new Promise(resolve => {
    const reader = new FileReader()

    reader.onload = e => {
      const { result } = e.target

      const data = JSON.parse(result)

      resolve(data)
    }

    reader.readAsText(file)
  })


const convertCsvToWorkbook = data => {
  if (!data) return

  const sheetNames = Object.keys(data)

  const sheets = Object.entries(data).reduce((result, [sheetName, csv]) => {
    // eslint-disable-next-line no-param-reassign
    result[sheetName] = XLSX.utils.json_to_sheet(csv)

    return result
  }, {})

  return { Sheets: sheets, SheetNames: sheetNames }
}

const convertCsvToExcel = data => {
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'

  const wb = convertCsvToWorkbook(data)
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })

  return new Blob([excelBuffer], { type: fileType })
}

const getExpressCourierType = type => {
  switch (type) {
    case 'same_day_delivery':
      return 'Same-Day Delivery'
    case 'cross_city_delivery':
      return 'Cross City Delivery'
    default:
      return 'Instant Delivery'
  }
}

const getExpressPendingStatus = orders => {
  return _.reduce(orders, (result, order) => {
    if (!['confirmed', 'outForDelivery', 'delivered', 'rejected'].includes(order.status)) {
      result[order.id] = order
    }

    return result
}, {})
}

export default {
  isDev,
  urlParams,
  getOrderStatus,
  getLoggedDevicePlatform,
  getBatteryStatus,
  getCreditStatusColor,
  getDriverStatusColor,
  getDriverStatistic,
  getRowsTimeSlot,
  getOrderEta,
  convertToCurrency,
  copyToClipboard,
  convertToLocalPhoneNumber,
  convertToCallableLink,
  convertToFixedTwo,
  urlParamsObjectify,
  numberWithCommas,
  convertArrayToObject,
  filterActiveSpecialDeal,
  filterSpecialDealByMerchant,
  numberToRiel,
  numberToUsd,
  getJsonDataFromExcel,
  getDataFromJSON,
  convertCsvToExcel,
  getExpressCourierType,
  getExpressPendingStatus,
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js